import { ROSQuestionnaire } from '../../../../../../lib/Questionnaires'
import { CheckboxInput, TextInput } from '../../../../../shared/FormBuilder'

function Genitourinary ({ disabled }) {
  return (
    <div className='row margin-top'>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.genitourinaryIncontinence}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.genitourinaryDysuria}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.genitourinaryHematuria}
        />
      </div>
      <div className='col-xs-12 margin-top'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.genitourinaryOther}
        />
      </div>
      <div className='col-xs-12'>
        <TextInput
          disabled={disabled}
          {...ROSQuestionnaire.genitourinaryOtherText}
        />
      </div>
    </div>
  )
}

export default Genitourinary
